<template>
  <div v-if="item">
    <h2>Заказ #{{ item.id }}</h2>

    <h4>Статус заказчика</h4>
    <div v-if="item.client && item.client.group && item.client.group.id">
      <h5>
        <b>{{ item.client.group.name }}</b>
      </h5>
    </div>
    <div v-else>Без статуса</div>
    <h4>Формат связи</h4>

    <!-- <div v-if="item.client"></div> -->
    <h5 class="mt-0">{{ item.format_display }}</h5>
    <small class="mt-0">{{ item.created_at }}</small>
    <h5><timer :item="item" /></h5>
    <h4>Дейтствия заказа</h4>
    <ul class="status">
      <li>
        <p-button
          class="btn-sm"
          type="warning"
          round
          @click.native.prevent="getPDF"
          >Скачать PDF</p-button
        >
      </li>
      <li v-if="item.format == 3">
        <p-button
          class="btn-sm"
          type="success"
          round
          @click.native.prevent="commentOrder('Связался по Telegram')"
          >Связался по Telegram</p-button
        >
      </li>
      <li v-if="item.format == 3">
        <p-button
          class="btn-sm"
          type="error"
          round
          @click.native.prevent="commentOrder('Не отвечает по Telegram')"
          >Не отвечает по Telegram</p-button
        >
      </li>
      <li v-if="item.format == 2">
        <p-button
          class="btn-sm"
          type="info"
          round
          @click.native.prevent="sendEmail"
          >Отправить на почту</p-button
        >
      </li>
      <li v-if="item.format == 1">
        <p-button
          class="btn-sm"
          type="success"
          round
          @click.native.prevent="commentOrder('Успешно позвонил')"
          >Успешно позвонил</p-button
        >
      </li>
      <li v-if="item.format == 1">
        <p-button
          class="btn-sm"
          type="errors"
          round
          @click.native.prevent="commentOrder('Не довонился')"
          >Не дозвонился</p-button
        >
      </li>
    </ul>
    <hr />
    <radio-list
      name="set-status"
      title="Изменить статус"
      :items="$store.state.listState"
      @change="updateItem"
      :value="item.status"
    />
    <hr />
    <h4>Данные о заказчике</h4>
    <div class="row">
      <div class="col-md-12">
        <fg-input type="text" label="Клиент" :value="item.name"></fg-input>
        <fg-input
          type="text"
          label="Контатный номер"
          :value="item.phone"
        ></fg-input>
        <fg-input type="text" label="Email" :value="item.email"></fg-input>
        <div class="form-group">
          <label class="control-label">Комментарий</label>
          <textarea v-model="item.comment" class="form-control"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import timer from "../../Timer";
import { errorNotify } from "../../../plugins/functions";
import RadioList from "../../Filters/RadioList";
/**Меняю добавление модалку */
export default {
  data: () => ({
    cardLink: "admin/orders/card",
    cardSetLink: "admin/orders/update",
    item: null,
  }),
  name: "groups",
  components: {
    /**Меняю добавление модалку */
    timer,
    RadioList,
  },
  props: ["id"],
  created() {
    this.getItem();
  },
  methods: {
    commentOrder(comment) {
      this.$loading(true);
      this.$http
        .post("admin/orders/state/set", {
          id: this.id,
          comment: comment,
        })
        .then((response) => {
          this.$notify({
            title: "Заказ",
            message: comment,
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((error) => {
          errorNotify(error, this);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    getPDF() {
      this.$loading(true);
      document.location.href = `https://api-server.glamourboutique.uz/api/admin/orders/notify/${this.item.hash}?type=pdf`;
      setTimeout(() => {
        this.$loading(false);
      }, 3000);
    },
    sendEmail() {
      this.$dialog
        .confirm(
          "Вы точно хотите отправить информацию о товарах на почту " +
            this.item.email +
            "?",
          {
            okText: "Отравить",
            cancelText: "Отмена",
          }
        )
        .then(() => {
          this.$loading(true);
          this.$http
            .get(`admin/orders/notify/${this.item.hash}`, {
              params: {
                type: "email",
                email: this.item.email,
              },
            })
            .then((response) => {
              this.commentOrder("Отправили на почту " + this.item.email);
            })
            .catch(() => {})
            .finally(() => {
              setTimeout(() => {
                this.$loading(false);
              }, 400);
            });
        })
        .catch(() => {});
    },
    getItem() {
      this.$loading(true);
      if (this.id) {
        this.$http
          .get(this.cardLink, {
            params: {
              id: this.id,
            },
          })
          .then((response) => {
            this.item = response.data;
          })
          .catch(() => {})
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
              this.$loading(false);
            }, 400);
          });
      }
    },
    updateItem(val) {
      this.item.status = val;
      this.loading = true;
      this.$loading(true);
      //

      this.$http
        .put(this.cardSetLink, this.item)
        .then((response) => {
          this.commentOrder("Изменили статус: " + response.data.state);
        })
        .catch((error) => {
          errorNotify(error, this);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
            this.$loading(false);
          }, 400);
        });
    },
  },
};
</script>
<style>
</style>
